import React from 'react'
import NumberInput from './NumberInput'
import styles from './SlopeInput.module.css'

class SlopeInput extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  handleChange (value) {
    this.props.onChange(value)
  }

  handleClick (e) {
    const where = e.target.id === 'btU' ? .1 : -.1
    let value = Math.max(this.props.value + where, 0)
    value = Math.round(value * 100) / 100
    this.props.onChange(value)
  }

  render () {
    return (
      <div className={styles.slopeInputContainer}>
        <button id='btD' onClick={this.handleClick}>▼</button>
        <NumberInput value={this.props.value} onChange={this.handleChange} />
        <button id='btU' onClick={this.handleClick} >▲</button>
      </div>
    )
  }
}

// SlopeInput.propTypes = {
//   value: PropTypes.number,
//   onChange: PropTypes.func
// }

export default SlopeInput
